<template>
	<div class="component-upload-image">
		<el-upload multiple :action="uploadImgUrl" list-type="picture-card" :on-success="handleUploadSuccess"
			:before-upload="handleBeforeUpload" :limit="limit" :on-error="handleUploadError" :on-exceed="handleExceed"
			ref="imageUpload" :on-remove="handleDelete" :show-file-list="true" :headers="headers" :file-list="fileList"
			:on-preview="handlePictureCardPreview" :class="{hide: this.fileList.length >= this.limit}">
			<i class="el-icon-plus"></i>
		</el-upload>



		<el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>
			<img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
		</el-dialog>
	</div>
</template>

<script>
	import {
		getItem
	} from "@/utils/auth";
	import {
		isExternal
	} from "@/utils/validate";
	import webConfig from "@/utils/global.config";
	export default {
		props: {
			value: [String, Object, Array],
			// 图片数量限制
			limit: {
				type: Number,
				default: 1,
			},
			// 大小限制 (MB)
			fileSize: {
				type: Number,
				default: 5,
			},
			// 文件类型，例如 ['png', 'jpg', 'jpeg']
			fileType: {
				type: Array,
				default: () => ["png", "jpg", "jpeg"],
			},
			// 是否显示提示
			isShowTip: {
				type: Boolean,
				default: true
			},
			isActive:Number
		},
		created() {

		},
		data() {
			return {
				number: 0,
				uploadList: [],
				dialogImageUrl: "",
				dialogVisible: false,
				hideUpload: false,
				baseUrl: webConfig.url, // 使用全局配置的图片 CDN 地址
				uploadImgUrl: 'https://api.rudaweiye.com/api/upload', // 上传的图片服务器地址
				headers: {
					Authorization: 'Bearer ' + getItem('x-Token'),
				},
				fileList: []
			};
		},
		watch: {
			value: {
				handler(val) {
					if (val) {
						// 首先将值转为数组
						const list = Array.isArray(val) ? val : this.value.split(',');

						// 然后将数组转为对象数组
						this.fileList = list.map(item => {
							if (typeof item === "string") {
								if (item.indexOf(this.baseUrl) === -1 && !isExternal(item)) {
									item = {
										name: this.baseUrl + item,
										url: this.baseUrl + item
									};
								} else {
									item = {
										name: item,
										url: item
									};
								}
							}
							return item;
						});
					} else {
						this.fileList = [];
						return [];
					}
				},
				deep: true,
				immediate: true
			}
		},
		computed: {
			// 是否显示提示
			showTip() {
				return this.isShowTip && (this.fileType || this.fileSize);
			},
		},
		methods: {
			// 上传前 loading 加载
			handleBeforeUpload(file) {
				let isImg = false;
				if (this.fileType.length) {
					let fileExtension = "";
					if (file.name.lastIndexOf(".") > -1) {
						fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
					}
					isImg = this.fileType.some(type => {
						if (file.type.indexOf(type) > -1) return true;
						if (fileExtension && fileExtension.indexOf(type) > -1) return true;
						return false;
					});
				} else {
					isImg = file.type.indexOf("image") > -1;
				}

				if (!isImg) {
					// this.$modal.msgError(`文件格式不正确，请上传${this.fileType.join("/")}图片格式文件!`);
					return false;
				}
				if (file.name.includes(',')) {
					this.$modal.msgError('文件名不正确，不能包含英文逗号!');
					return false;
				}
				if (this.fileSize) {
					const isLt = file.size / 1024 / 1024 < this.fileSize;
					if (!isLt) {
						this.$modal.msgError(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
						return false;
					}
				}
				this.$modal.loading("正在上传图片，请稍候...");
				this.number++;
			},
			// 文件个数超出
			handleExceed() {
				this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`);
			},
			// 上传成功回调
			handleUploadSuccess(res, file) {

				if (res.code === 1) {

					// this.uploadList.push({
					// 	name: res.data.fileName,
					// 	url: res.msg.filepath
					// });
					this.uploadList.push({
						// name: res.data.name,
						// url: res.data.url
						url:  res.url
					});

					// console.log(res.msg.filename,res.msg.filepath)
					// console.log(this.uploadList)
					this.uploadedSuccessfully();
				} else {
					this.number--;
					this.$modal.closeLoading();
					this.$modal.msgError(res.msg);
					this.$refs.imageUpload.handleRemove(file);
					this.uploadedSuccessfully();
				}
			},
			// 删除图片
			handleDelete(file) {
				const findex = this.fileList.map(f => f.name).indexOf(file.name);
				if (findex > -1) {
					this.fileList.splice(findex, 1);
					this.$emit("input", this.listToString(this.fileList));
				}
			},
			// 上传失败
			handleUploadError() {
				this.$modal.msgError("上传图片失败，请重试");
				this.$modal.closeLoading();
			},
			// 上传结束处理
			uploadedSuccessfully() {
				if (this.number > 0 && this.uploadList.length === this.number) {
					this.uploadList.forEach(item => {
						// 如果 URL 已经是完整路径（包含 http 或 https），则不拼接
						if (!item.url.startsWith('http://') && !item.url.startsWith('https://')) {
							item.url = webConfig.url + item.url;
						}
					})
					this.fileList = this.fileList.concat(this.uploadList);
					console.log('上传成功',this.fileList)
					this.uploadList = [];
					this.number = 0;
					this.$emit("input", this.listToString(this.fileList));
					this.$modal.closeLoading();
				}
			},
			// 预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			// 对象转成指定字符串分隔
			listToString(list, separator) {
				let strs = "";
				separator = separator || ",";
				for (let i in list) {
					if (list[i].url) {
						strs += list[i].url.replace(this.baseUrl, "") + separator;
					}
				}
				return strs != '' ? strs.substr(0, strs.length - 1) : '';
			}
		}
	};
</script>
<style scoped lang="scss">
	// .el-upload--picture-card 控制加号部分
	::v-deep.hide .el-upload--picture-card {
		display: none;
	}

	// 去掉动画效果
	::v-deep .el-list-enter-active,
	::v-deep .el-list-leave-active {
		transition: all 0s;
	}

	::v-deep .el-list-enter,
	.el-list-leave-active {
		opacity: 0;
		transform: translateY(0);
	}

	// 身份证图片样式 - 调整为长方形（宽高比约 1.6:1）
	::v-deep .el-upload--picture-card {
		width: 160px;
		height: 100px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	::v-deep .el-icon-plus {
		font-size: 24px;
	}

	::v-deep .el-upload-list__item {
		width: 160px;
		height: 100px;
	}

	::v-deep .el-upload-list__item-thumbnail {
		width: 100%;
		height: 100%;
		object-fit: contain; // 保持图片比例，不拉伸
	}
</style>
